import { Id, IMetadata } from '@/shared/types/builtInTypes'
import { ICustomerList } from '@/modules/customer/types/customerTypes'
import { TranslateResult } from 'vue-i18n'

export enum ReturnReasonTypeChoices {
  iDoNotLikeTheModel = `I don't like the model`,
  missingPiecesAccessoriesInTheProduct = `Missing pieces/accessories in the product`,
  cargoDeliveryDelay = 'Cargo Delivery Delay',
  defectiveProduct = 'Defective Product',
  wrongProduct = 'Wrong Product',
  productHasWrongCharacteristics = `Product has Wrong Characteristics`,
  usedDamagedProduct = `Used / Damaged Product`,
  iDoNotLikeTheQuality = `I don't like the quality`
}

export enum ItemStatus {
  PROCESSING = 'processing',
  COLLECTED = 'collected',
  PACKED = 'packed',
  CANCELLED = 'cancelled',
  DELIVERED = 'delivered',
  DELAYED = 'delayed',
  BOOKED = 'Booked',
  PENDING = 'pending'
}

export const itemStatusColors: Record<ItemStatus | string, string> = {
  [ItemStatus.PENDING]: 'warning',
  [ItemStatus.PROCESSING]: 'warning',
  [ItemStatus.PACKED]: 'info',
  [ItemStatus.CANCELLED]: 'error',
  [ItemStatus.DELIVERED]: 'success',
  [ItemStatus.COLLECTED]: 'info',
  [ItemStatus.DELAYED]: 'warning',
  [ItemStatus.BOOKED]: 'onSurfaceMedium'
}

export enum DelayStatus {
  escalated = 'escalated',
  safe = 'safe',
  warning = 'warning'
}

export const delayStatusColors: Record<DelayStatus | string, string> = {
  [DelayStatus.escalated]: 'error',
  [DelayStatus.safe]: 'success',
  [DelayStatus.warning]: 'warning'
}

export enum PaymentStatus {
  unpaid = 'unpaid',
  paid = 'paid',
  cashOnDelivery = 'cash_on_delivery',
  partialPaid = 'partial_paid',
  refunded = 'refunded'
}

export const paymentStatusColors: Record<PaymentStatus | string, string> = {
  [PaymentStatus.unpaid]: 'error',
  [PaymentStatus.paid]: 'success',
  [PaymentStatus.cashOnDelivery]: 'error',
  [PaymentStatus.partialPaid]: 'warning',
  [PaymentStatus.refunded]: 'info'
}

export enum CashoutStatus {
  RETURN_PERIOD = 'return_period',
  WAITING_PERIOD = 'waiting_period',
  READY_FOR_CASHOUT = 'ready_for_cashout',
  CASHED_OUT = 'cashed_out',
  AWAITING_DELIVERY = 'awaiting_delivery',
  ORDER_CANCELED = 'order_canceled'
}

export const cashoutStatusColors: Record<CashoutStatus | string, string> = {
  [CashoutStatus.CASHED_OUT]: 'variantSurface',
  [CashoutStatus.READY_FOR_CASHOUT]: 'success',
  [CashoutStatus.RETURN_PERIOD]: 'warning',
  [CashoutStatus.WAITING_PERIOD]: 'info',
  [CashoutStatus.AWAITING_DELIVERY]: 'warning',
  [CashoutStatus.ORDER_CANCELED]: 'error'
}

export interface ICurrencyRateDetail {
  rate: number
  currencyName: string
}

export interface IOrderItems extends IMetadata {
  id: Id
  url: string
  unitPrice: number
  discountAmount: number
  netSale: number
  unitToBePaid: number
  toBePaid: number
  quantity: number
  invoiceNumber: string
  productName: string
  returnStatus: string | null
  variantOptions: {
    name: string
    value: string
  }[]
  productVariantOptions: {
    name: string
    value: string
  }[]
  taxCost: number
  toBeCollected: number
  totalAmount: number
  totalLogistic: number
  internationalLogisticCost: number
  localDeliveryCost: number
  localDeliveryPrice: number
  totalTax: number
  totalCommission: number
  sellerSku: string
  systemSku: string
  orderNumber: string
  delayStatus: DelayStatus
  itemStatus: ItemStatus
  paymentStatus: PaymentStatus
  cashoutStatus: CashoutStatus
  customer: ICustomerList
  customerFullName: string
  customerId: Id
  customerPhone: number
  storeName: string
  currencyRateDetail: ICurrencyRateDetail
  paymentOptions: string[]
  productId: string
  merchantId: Id
  weight: string
  images: { image: string; id: Id }[]
  orderItemStatusTracking: {
    id: Id
    status: ItemStatus
    delayStatus: DelayStatus
    note: string
    createdAt: string
  }[]
  returnReason: string
  notes: string
  returnDate: string
  returnType: string
  merchantAddress: string
  merchantPhone: string
  countryName: string
  orderItemId: Id
  note: string
  inspectionOutcome: string
  paymentOptionName: string
  customerAddress: string
  customerAddressTitle: string
}

export interface IOrderItemDetails {
  text: TranslateResult
  value: string | number
}
